import i18next from "i18next";
import { custom, success, failure } from "./utilities";
import {
  StorageKeys,
  loginConstants,
  globalSystemConstants,
  centerInstructorsConstants,
} from "../../constants";
import { UserActions } from "./user.actions";
import { ToastifyService, centerInstructorsService } from "../../services";
import { setLocalStorageItem, setSessionStorageItem } from "../../system";

const {
  GET_INSTRUCTOR_BY_EMAIL,
  GET_CENTER_INSTRUCTORS,
  GET_CENTER_INSTRUCTOR_DETAIL_BY_ID,
  RESET_INSTRUCTOR_DETAILS,
  OPEN_HEAD_INSTRUCTOR_MODAL,
} = centerInstructorsConstants;

const getCenterInstructors = (centerId, params) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );

    centerInstructorsService
      .getCenterInstructors(centerId, params)
      .then((response) => {
        dispatch(success(response, GET_CENTER_INSTRUCTORS));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const getInstructorByEmail = (email) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );

    centerInstructorsService
      .getInstructorByEmail(email)
      .then((response) => {
        dispatch(success(response, GET_INSTRUCTOR_BY_EMAIL));
      })
      .catch((error) => {
        ToastifyService.showError(error);
        dispatch(failure(null, GET_INSTRUCTOR_BY_EMAIL));
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const addCenterInstructor = (centerId, instructorId, gridState, setShow) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );

    centerInstructorsService
      .addCenterInstructor(centerId, instructorId)
      .then((message) => {
        ToastifyService.showSuccess(i18next.t(message));
        dispatch(UserActions.OpenModal(false));
        setShow(false);
        dispatch(resetInstructorDetails());
        dispatch(getCenterInstructors(centerId, gridState));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const removeCenterInstructor = (centerId, instructorId, gridState) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );

    centerInstructorsService
      .removeCenterInstructor(centerId, instructorId)
      .then((message) => {
        ToastifyService.showSuccess(i18next.t(message));
        dispatch(UserActions.OpenModal(false));
        dispatch(getCenterInstructors(centerId, gridState));
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const removeCenterInstructorByAdmin = (centerId, instructorId, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    centerInstructorsService
      .removeCenterInstructorByAdmin(centerId, instructorId)
      .then((message) => {
        ToastifyService.showSuccess(i18next.t(message));
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const approveRejectCenterInstructorRequest = (
  IsApproved,
  instructorId,
  onSuccess
) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );
    centerInstructorsService
      .approveRejectCenterInstructorRequest(IsApproved, instructorId)
      .then((message) => {
        ToastifyService.showSuccess(i18next.t(message));
        setLocalStorageItem(StorageKeys.instructorInvitedCenterName, null);
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const getCenterInstructorDetailById = (id, centerId) => {
  return (dispatch) => {
    dispatch(
      custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_ACTIVATE)
    );

    centerInstructorsService
      .getCenterInstructorDetailById(id, centerId)
      .then((response) => {
        dispatch(success(response, GET_CENTER_INSTRUCTOR_DETAIL_BY_ID));
      })
      .catch((error) => {
        ToastifyService.showError(error);
        dispatch(failure(null, GET_CENTER_INSTRUCTOR_DETAIL_BY_ID));
      })
      .finally(() => {
        dispatch(
          custom(loginConstants.LOGIN, globalSystemConstants.SPINNER_DEACTIVATE)
        );
      });
  };
};

const resetInstructorDetails = () => {
  return (dispatch) => {
    dispatch(success("", RESET_INSTRUCTOR_DETAILS));
  };
};

export const openHeadInstructorModal = (value) => {
  return (dispatch) => {
    dispatch(success(value, OPEN_HEAD_INSTRUCTOR_MODAL));
  };
};

export const centerInstructorsActions = {
  getInstructorByEmail,
  addCenterInstructor,
  getCenterInstructors,
  removeCenterInstructor,
  removeCenterInstructorByAdmin,
  getCenterInstructorDetailById,
  approveRejectCenterInstructorRequest,
  resetInstructorDetails,
  openHeadInstructorModal
};
